<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_22548_33983)">
      <path
        d="M11.9999 20.9995C11.8683 21.0003 11.7378 20.9751 11.616 20.9253C11.4941 20.8755 11.3833 20.8022 11.2899 20.7095L3.51987 12.9295C2.54523 11.9447 1.99854 10.6151 1.99854 9.22953C1.99854 7.84396 2.54523 6.51435 3.51987 5.52953C4.50213 4.55004 5.8327 4 7.21987 4C8.60704 4 9.93761 4.55004 10.9199 5.52953L11.9999 6.60953L13.0799 5.52953C14.0621 4.55004 15.3927 4 16.7799 4C18.167 4 19.4976 4.55004 20.4799 5.52953C21.4545 6.51435 22.0012 7.84396 22.0012 9.22953C22.0012 10.6151 21.4545 11.9447 20.4799 12.9295L12.7099 20.7095C12.6164 20.8022 12.5056 20.8755 12.3838 20.9253C12.2619 20.9751 12.1315 21.0003 11.9999 20.9995ZM7.21987 5.99953C6.79655 5.99761 6.37705 6.07971 5.98568 6.24106C5.59431 6.40242 5.23884 6.63982 4.93987 6.93953C4.33593 7.54665 3.99691 8.36818 3.99691 9.22453C3.99691 10.0809 4.33593 10.9024 4.93987 11.5095L11.9999 18.5795L19.0599 11.5095C19.6638 10.9024 20.0028 10.0809 20.0028 9.22453C20.0028 8.36818 19.6638 7.54665 19.0599 6.93953C18.4435 6.35724 17.6278 6.03282 16.7799 6.03282C15.932 6.03282 15.1162 6.35724 14.4999 6.93953L12.7099 8.73953C12.6169 8.83326 12.5063 8.90765 12.3844 8.95842C12.2626 9.00919 12.1319 9.03533 11.9999 9.03533C11.8679 9.03533 11.7372 9.00919 11.6153 8.95842C11.4934 8.90765 11.3828 8.83326 11.2899 8.73953L9.49987 6.93953C9.2009 6.63982 8.84544 6.40242 8.45406 6.24106C8.06269 6.07971 7.6432 5.99761 7.21987 5.99953Z"
        fill="#888888"
      />
    </g>
    <defs>
      <clipPath id="clip0_22548_33983">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 -0.000488281)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
